/**
 * Created by Ning Jiang on 11/24/2016.
 */

import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {IWinRatioConfig, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";

export class TombOfNefertitiSoundConfig implements ISoundConfig {

    public static instance: TombOfNefertitiSoundConfig = new TombOfNefertitiSoundConfig();
    AS_WIN:string="asWin";
    AS_WIN_BIG:string="asWinBig";
    MAIN_GAME_AMBIANCE: string = "music_main";
    BONUS_GAME_AMBIANCE: string = "music_fs2";

    REELS_SPINNING: string = "reelSpinning";
    REEL_LANDING: string = "reelLanding";

    NEFERTITI_TRIGGER: string = "nefertiti_trigger";
    NEFERTITI_FLAME_APPEAR: string = "nefertiti_flame_appear";
    NEFERTITI_FLAME_LOOP: string = "nefertiti_flame_loop";
    NEFERTITI_FLAME_EXTINGUISH: string = "nefertiti_flame_extinguish";

    RAIDER_TRIGGER: string = "raider_trigger";
    RAIDER_FLAME_APPEAR: string = "raider_flame_appear";
    RAIDER_FLAME_LOOP: string = "raider_flame_loop";
    RAIDER_FLAME_LOCK: string = "raider_flame_lock";

    BET_LINE: string = "line_win";
    BET_LINE_BIG_WIN: string = "bigwin_lines";

    WIN_TINY:string = "win-tiny";
    WIN_SMALL:string = "win-small";
    WIN_MEDIUM:string = "win-medium";
    WIN_LARGE:string = "win-large";

    BIG_WIN: string[] = ["bigWinSmall", "bigWinMed", "bigWinLarge"];

    INITIAL_WIN_COUNT_UP_END: string = "countup_ends2";

    COUNT_UP: string = "countup";

    MULTIPLIER_BURST: string = "win-amount_burst";

    COIN_SPLASH_FOUNTAIN: string = "coin_fountainSplash";

    WILD_LANDING: string = "wild_landing";
    WILD_RAIDER_LANDING: string = "wild_raider_landing";

    ANTICIPATION: string = "anticipation_bonus";
    ANTICIPATION_FAIL: string = "anticipationFail";
    ANTICIPATION_PER_TILE: string = "anticipation_per_tile";

    SCATTER_LANDING: string = "scatter_landing-normal";
    SCATTER_LANDING_FS: string = "fs_scatter_landing";
    SCATTER_LANDING_COUNT_1: string = "scatter_landing1";
    SCATTER_LANDING_COUNT_3: string = "scatter_landing3new";

    FS_ADDITIONAL_SCATTER_AWARD: string = "fs_outro_explosion";

    FIRE_BURST: string = "fire_burst";

    FS_BETLINE_INDICATOR_REVEAL: string = "fs_betline_reveal";
    FS_BETLINE_INDICATOR_REVEAL_END: string = "fs_betline_reveal_end";

    FS_INTRO: string = "fs_intro";
    FS_INTRO_PAPER_OPEN: string = "fs-paperopen";
    FS_INTRO_PAPER_CLOSE: string = "fs_paperclose";

    MULTIPLIER_UPDATE: string = "multiplier_update";
    FS_MULTIPLIER_UPDATE: string = "fs_multiplier_update";
    FS_NEW_MULTIPLIER_REVEAL: string = "fs_new_multiplier_reveal";

    FS_OUTRO_TEXT_REVEAL: string = "fs_outro_text_reveal";

    WIN_AMOUNT_UP: string = "winAmountUp";
    WIN_TOTAL: string = "winTotal";

    constructor() {
        if (TombOfNefertitiSoundConfig.instance) {
            throw new Error("TombOfNefertitiSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }

    static getNormalWinSoundName(winRatioConfig: IWinRatioConfig):any {
        if(!winRatioConfig) {
            return null;
        }
        switch(winRatioConfig.type) {
            case WinRatioType.TINY:
                return this.instance.WIN_TINY;
            case WinRatioType.SMALL:
                return this.instance.WIN_SMALL;
            case WinRatioType.MEDIUM:
                return this.instance.WIN_MEDIUM;
            case WinRatioType.LARGE:
                return this.instance.WIN_LARGE;
            default:
                return null;
        }
    }
}